<div class="kr-spinner"><i class="kr-loader"></i></div>